<!-- Footer.svelte -->
<script>
  // Get the current year
  const year = new Date().getFullYear();
</script>

<footer>
  <div class="footer-topper">
    <!-- You can add additional content here if needed -->
  </div>
  <div class="footer-content">
    <p>Copyright © 2019 - {year} Freedom Writers Foundation</p>
  </div>

  <style>
    footer {
      width: 100%;
      bottom: 0;
      left: 0;
      font-family: Arial, sans-serif; // Assuming Arial is the font you want to use
    }

    .footer-topper {
      background-color: #222222; /* Replace with the exact grey color code */
      padding: 5px 0; /* Adjust to your preference */
      height: 52px;
    }

    .footer-content {
      background-color: #1A1A1A; /* Black background */
      color: #4A4A4A;
      text-align: center;
      padding: 10px 0; /* Adjust padding to match your screenshot */
    }

    .footer-content p {
      margin: 0;
      font-size: 16px; /* Adjust font-size to match your screenshot */
    }
  </style>
</footer>
